import React, { useContext, useEffect, useState } from "react";
import { LoanCalculatorWrapper } from "./style";
import img from "../../images/loan_calculation.png";
import RangeSlider from "../RangeSlider/RangeSlider";
import principalIcon from "../../images/Principal.svg";
import emiIcon from "../../images/EMI.svg";
import paybleIcon from "../../images/Total payble.svg";
import { getStorage, setStorage } from "../../Utils/common";
import Button from "../ui/Button";
import ContextDashboard from "../../Context/ContextDashboard";
import { calculateLoan, generateLoan } from "../../Utils/api";
import { useNavigate } from "react-router-dom";
import Select from "../../components/ui/Select";
import ProgressBar from "../../components/ProgressBar/ProgressBar";
import { Calculator, Info, IndianRupee } from "lucide-react";
const initialData = {
  loanPurpose: "",
};

const options = [
  { label: "Travel", value: "1" },
  { label: "Medical", value: "2" },
  { label: "Shopping", value: "3" },
  { label: "Others", value: "4" },
];

function LoanCalculator() {
  const [principal, setPrincipal] = useState(100000);
  const [tenure, setTenure] = useState(7);
  const [emi, setEmi] = useState(0);
  const [loadingAccept, setLoadingAccept] = useState(false); // Loading state for Accept button
  const [loadingReject, setLoadingReject] = useState(false); // Loading state 
  const [formData, setFormData] = useState(initialData);
  const [formDataError, setFormDataError] = useState(initialData);
  const [progressBar, setProgressBar] = useState(getStorage("percent"));
  const [loanData, setLoanData] = useState([]);

  const { setMessage, logout, handleEvent } = useContext(ContextDashboard);

  useEffect(() => {
    const params = {
      profile_id: getStorage("cust_profile_id") || "",
      event_name: "generate_loan_quote",
    };
    generateLoan(params).then((resp) => {
      if (resp?.data?.Status === 1) {
        setStorage("percent", resp?.data?.Data?.step_percentage);
        setProgressBar(resp?.data?.Data?.step_percentage);
        setLoanData(resp?.data?.Data);
      }
    });
  }, []);

  const submit = (acceptedId) => {
    const param = {
      profile_id: getStorage("cust_profile_id") || "",
      event_name: "loan_quotation_decision",
      tenure: tenure,
      purpose_id: formData.loanPurpose,
      amount: principal,
      accepted_id: acceptedId, // Pass the accepted_id here
    };

    // Set loading state depending on whether the user clicked "Accept" or "Reject"
    if (acceptedId === "1") {
      setLoadingAccept(true); // Start loading for "Accept"
      setLoadingReject(false); // Ensure "Reject" is not loading
    } else if (acceptedId === "2") {
      setLoadingReject(true); // Start loading for "Reject"
      setLoadingAccept(false); // Ensure "Accept" is not loading
    }

    calculateLoan(param).then((resp) => {
      // Reset the loading state after the request completes
      if (acceptedId === "1") setLoadingAccept(false); // Stop loading for "Accept"
      if (acceptedId === "2") setLoadingReject(false); // Stop loading for "Reject"

      if (resp?.data?.Status === 1) {
        setStorage("next_step", resp?.data?.Data?.next_step);
        setStorage("percent", resp?.data?.Data?.step_percentage);
        setProgressBar(resp?.data?.Data?.step_percentage);
        setMessage({
          type: "success",
          msg: resp?.data?.Message,
          place: "global",
        });
        handleEvent(getStorage("next_step"));
      } else if (resp?.data?.Status === 4) {
        logout();
      } else {
        setMessage({ type: "error", msg: resp?.data?.Message });
      }
    });
  };

  const onChange = (e) => {
    let { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setFormDataError({ ...formDataError, [name]: "" });
  };

  useEffect(() => {
    let si = (principal * tenure) / 100;
    setEmi(si);
  }, [principal, tenure]);

  return (
    <>
      <LoanCalculatorWrapper className="flex">


        <div className="left">
          <div className="w-full h-full min-h-[700px] rounded-2xl bg-gradient-to-b from-[#4FA0FF] to-[#2F6BFF] p-8 flex flex-col text-white">

            {/* Illustration */}
            <div className="flex-1 flex flex-col items-center justify-center">

              <div className="relative mb-8">
                <div className="absolute inset-0 w-48 h-48 rounded-full bg-white/10 blur-sm m-auto" />

                <div className="relative flex items-end justify-center">

                  {/* Paper */}
                  <div className="w-32 h-40 bg-white rounded-xl shadow-xl flex flex-col items-center justify-center">
                    <Calculator className="w-12 h-12 text-blue-600 mb-3" />

                    <div className="space-y-2">
                      <div className="w-12 h-1 bg-blue-200 rounded-full"></div>
                      <div className="w-10 h-1 bg-blue-200 rounded-full"></div>
                      <div className="w-12 h-1 bg-blue-200 rounded-full"></div>
                    </div>
                  </div>

                  {/* Calculator */}
                  <div className="absolute right-[-10px] bottom-2 w-20 h-24 rounded-xl bg-[#1E5BD9] shadow-xl flex items-center justify-center">
                    <Calculator className="w-10 h-10 text-white" />
                  </div>

                  {/* Rupee */}
                  <div className="absolute left-[-12px] bottom-2 w-12 h-12 rounded-full bg-[#6EA8FF] border-2 border-white flex items-center justify-center">
                    <IndianRupee className="w-6 h-6 text-white" />
                  </div>
                </div>
              </div>

              <h2 className="text-4xl font-bold text-center">
                Let's calculate your loan
              </h2>

              <p className="mt-4 max-w-sm text-center text-blue-100 leading-7">
                Provide the details on the right to calculate your loan
                eligibility and repayment.
              </p>
            </div>

            {/* Bottom Info */}
            <div className="mt-8 rounded-xl bg-white/90 p-5 flex items-center gap-4">

              <div className="w-12 h-12 rounded-full bg-blue-500 flex items-center justify-center shrink-0">
                <Info className="w-6 h-6 text-white" />
              </div>

              <p className="text-gray-700 text-sm leading-6">
                We have calculated your loan eligibility based on the
                details you provide.
              </p>

            </div>
          </div>
        </div>



        <div className="right">
          <div className="box">
            <div className="flex space-between ">
              <h2 className="text-[#1B2A57] font-bold">
                Purpose of Loan <span className="text-orange-500">*</span>
              </h2>
            </div>
            <div className="center">
              <Select
                className="selectLoanPurpose"
                name="loanPurpose"
                placeholder="--select--"
                error={formDataError?.loanPurpose}
                onChange={onChange}
                value={formData.loanPurpose}
                options={options}
              />
            </div>
          </div>
          <div className="box">
            <div className="flex space-between">
              <h2 className="text-[#1B2A57] font-bold">
                Principal <span className="text-orange-500">*</span>
              </h2>
              <span className="value">₹ {principal}</span>
            </div>
            <div className="center">
              {/* <input
                type="number"
                min={loanData?.min_loan_amount}
                max={loanData?.max_loan_amount}
                step="500"
                value={principal}
                onChange={(e) => setPrincipal(Number(e.target.value))}
              /> */}
              <RangeSlider
                min={loanData?.min_loan_amount || 5000}
                step="1000"
                max={loanData?.max_loan_amount || 100000}
                value={principal}
                setValue={setPrincipal}
              />
            </div>
          </div>
          <div className="box">
            <div className="flex space-between">
              <h2 className="text-[#1B2A57] font-bold">
                Tenure <span className="text-orange-500">*</span>
              </h2>
              <span className="value"> Tenure fixed for {tenure} Days</span>
            </div>
            <div className="center">
              <RangeSlider
                min={loanData?.min_loan_tenure || 7}
                step="1"
                max={loanData?.max_loan_tenure || 45}
                value={tenure}
                setValue={setTenure}
              />
            </div>
          </div>
          <div className="cards">
            <div className="card">
              <div className="img">
                <img src={principalIcon} alt="icon" />
              </div>
              <div className="desc">
                <h3>PRINCIPAL</h3>
                <h2>₹ {principal}</h2>
              </div>
            </div>
            <div className="card">
              <div className="img">
                <img src={paybleIcon} alt="icon" />
              </div>
              <div className="desc">
                <h3>TOTAL PAYABLE</h3>
                <h2>₹ {Number(principal) + Number(emi)}</h2>
              </div>
            </div>
          </div>
          <Button
            title={"Accept"}
            onClick={() => submit("1")}
            loading={loadingAccept}
          />
          {/* <Button title={"Reject"} onClick={() => submit("2")} loading={loadingReject} /> */}
        </div>
      </LoanCalculatorWrapper >
    </>
  );
}

export default LoanCalculator;